import React, { useContext } from 'react';

import './FooterAbout.scss';
import { LanguageContext } from '../../../context/language-context';

const FooterAbout = ({ className }) => {
  const lng = useContext(LanguageContext);
  const { language } = lng;

  return (
    <div className={`footer-about ${className}`}>
      <h4 className="footer-about__title">
        {language === 'en' ? 'about xxxxx' : 'xxxxxについて'}
      </h4>
      <p className="footer-about__description">
        {language === 'en'
          ? `Aliquam suscipit metus a est sodales, et varius diam pulvinar. Duis
        iaculis tortor in urna ullamcorper accumsan ac nec urna. Maecenas at
        vehicula nunc, non congue urna. Lorem ipsum dolor sit amet, consectetur
        adipiscing elit. Sed tristique venenatis magna, at fringilla nisi dictum
        id. Nunc a purus non neque lobortis egestas volutpat in ipsum.`
          : 'ここも事実はなはだこの経過院という事の中をやっでない。よほど毎号に立脚人は無論その著作ませましなどと見えているたをも関係弱らありませて、当然には蒙りたたんあり。利器を蒙りうのは単に事実に実にだっませた。ざっと大森さんに矛盾申たった料簡を出かけた個性この中学あなたか学習にというお変化たんんんから、その近頃も何かご覧魚籃を見えて、木下さんののをがたの何をもっと同任命と思わからあなた他を皆融和に続いようにそんなにお招待を潜んですですば、何しろいくら発達を用いですているな事と果せるうなかっ。'}
      </p>
    </div>
  );
};

export default FooterAbout;
